import { EmployeeFoldersDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

export const useGetEmployeeFolder = (employeeIds: string[]) => {
  const { data, loading } = useQuery(EmployeeFoldersDocument, {
    variables: { employeeIds },
    fetchPolicy: 'no-cache',
  })

  const employeeFolders = data?.employees?.employees?.flatMap((employee) => employee.folders)
  const editableEmployeeFolders = employeeFolders
    ?.filter((employee) => employee._policies?.edit.can)
    .map((p) => p.folder)

  return {
    employeeFolders,
    editableEmployeeFolders,
    loading: loading,
  }
}
